export const SET_TOKEN = 'SET_TOKEN';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const SET_PROFILE = 'SET_PROFILE';
export const CLEAR = 'CLEAR';
